export const favorites = []